// src/components/device-components/RegisteredDeviceComponent.jsx
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Paper,
} from "@mui/material";
import DevicesOutlinedIcon from "@mui/icons-material/DevicesOutlined";
import deviceStore from "../../stores/DeviceStore";
import DeviceGrid from "./DeviceGrid";
import DeviceList from "./DeviceList";

const RegisteredDeviceComponent = observer(() => {
  const [viewMode, setViewMode] = useState("grid");

  useEffect(() => {
    deviceStore.loadDevices();
  }, []);

  const handleViewChange = (_, newView) => {
    if (newView) setViewMode(newView);
  };

  const showEmptyState =
    !deviceStore.isLoading && deviceStore.registeredDevices.length === 0;

  const error = deviceStore.error;
  const errorMessage = deviceStore.errorMessage;
  console.log("here is error: ", error);

  const isRegionEmptyError =
    error === 406 && errorMessage?.includes("Empty region list");

  return (
    <Box>
      {/* Header + Toggle Buttons */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Registered Devices
        </Typography>
        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={handleViewChange}
          aria-label="View Mode"
        >
          <ToggleButton value="grid" aria-label="Grid View">
            GRID VIEW
          </ToggleButton>
          <ToggleButton value="table" aria-label="Table View">
            TABLE VIEW
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* Main Content */}
      {showEmptyState ? (
        <Paper
          elevation={1}
          sx={{
            borderRadius: 3,
            p: 5,
            textAlign: "center",
            bgcolor: "background.paper",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            minHeight: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {/* Icon Circle */}
          <Box
            sx={{
              width: 90,
              height: 90,
              borderRadius: "50%",
              bgcolor: "primary.light",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 2,
            }}
          >
            <DevicesOutlinedIcon sx={{ fontSize: 48, color: "primary.main" }} />
          </Box>

          {/* Main Title */}
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, mb: 1, color: "text.primary" }}
          >
            {isRegionEmptyError
              ? "No Regions Assigned"
              : "No Registered Devices"}
          </Typography>

          {/* Subtitle */}
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ maxWidth: 400, mx: "auto", mb: 3 }}
          >
            {isRegionEmptyError
              ? "You don’t have any regions assigned. Once a region is assigned, your registered devices will appear here."
              : "You currently don’t have any registered devices. When you gain access to one, it will be displayed here."}
          </Typography>
        </Paper>
      ) : viewMode === "grid" ? (
        <DeviceGrid
          devices={deviceStore.registeredDevices}
          loading={deviceStore.isLoading}
        />
      ) : (
        <DeviceList
          devices={deviceStore.registeredDevices}
          loading={deviceStore.isLoading}
        />
      )}
    </Box>
  );
});

export default RegisteredDeviceComponent;
